var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataIncompleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.698,
    height: 83.83,
    viewBox: "0 0 83.698 83.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#1a8cff;}.c,.d{fill:#b9e1ff;}.d{stroke:#ff2467;stroke-width:3px;}.e{fill:#00429a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,41.849A41.849,41.849,0,1,0,41.849,0,41.854,41.854,0,0,0,0,41.849Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.525 -15.176)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.468-.207s9.921-.315,18.475,3.9S66.685,16.641,66.685,16.641l-.174,44.477c0,10.583.856,19.161-7.54,19.161H8.19C-.207,80.279,0,71.7,0,61.118L-.319,16.656s6.4-8.058,14.6-12.273S32.468-.207,32.468-.207Z",
    transform: "translate(92.508 98.793) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160,176h32.66v4.83H160Z",
    transform: "translate(-117.811 -127.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160,240h32.66v4.83H160Z",
    transform: "translate(-117.811 -182.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160,240h32.66v4.83H160Z",
    transform: "translate(-117.811 -201.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160,240h32.66v4.83H160Z",
    transform: "translate(-117.811 -210.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160,304h29.753v7.344H160Z",
    transform: "translate(-116.244 -236.383)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 32.66,
    height: 11.83,
    rx: 1,
    transform: "translate(42.189 80.107)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIncompleteIcon);
export default __webpack_public_path__ + "static/media/data-incomplete-icon.09d4511a87b953b64cd589fdf1dd9002.svg";
export { ForwardRef as ReactComponent };